export default "__VITE_ASSET__Bd$nkhoY__"